import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";

// Fontlar pakete gömülü: site Google Fonts'tan yüklüyordu ama eklentinin CSP'si
// (style-src 'self') o isteği engelliyor, saat ve yazılar sistem fontuna düşüyordu.
// Yerel woff2 iki yüzeyde de aynı görünümü verir; kurumsal ağda/çevrimdışı da çalışır.
import "@fontsource/dm-sans/400.css";
import "@fontsource/dm-sans/500.css";
import "@fontsource/dm-sans/600.css";
import "@fontsource/dm-sans/700.css";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/600.css";
import "@fontsource/space-grotesk/700.css";
import "./styles.css";
import { getRouter } from "./router";

const router = getRouter();

const el = document.getElementById("root");
if (!el) throw new Error("#root not found");

createRoot(el).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
